// extracted by mini-css-extract-plugin
export default {"nav":"style_navigation_nav__v8nQ2","navList":"style_navigation_navList__ymOcv","navLink":"style_navigation_navLink__yJ0VN"};